import * as React from 'react'
import Box from '@mui/joy/Box'
import Typography from '@mui/joy/Typography'
import { EmailRecord } from './types'

interface EmailListItemProps {
    email: EmailRecord
    selected?: boolean
    onClick: () => void
}

function formatEmailDate(ts: number) {
    const now = new Date()
    const date = new Date(ts)
    const isToday = date.getFullYear() === now.getFullYear() && date.getMonth() === now.getMonth() && date.getDate() === now.getDate()
    if (isToday) {
        return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    }
    return date.toLocaleString('en-US', { month: 'short', day: 'numeric' })
}

export default function EmailListItem({ email, selected, onClick }: EmailListItemProps) {
    const obj = email.emailData.object
    const from = obj.from?.[0]?.name || obj.from?.[0]?.email || 'Unknown'
    return (
        <Box
            onClick={onClick}
            sx={{
                display: 'flex',
                alignItems: 'center',
                px: 2,
                py: 1,
                cursor: 'pointer',
                bgcolor: selected ? 'primary.softBg' : 'background.body',
                fontWeight: selected ? 700 : 400,
                borderLeft: selected ? '4px solid #1976d2' : '4px solid transparent',
                minHeight: 40,
                transition: 'background 0.18s',
                '&:hover': { bgcolor: 'neutral.softBg' },
                gap: 2,
                borderRadius: '6px',
                mb: 0.5,
                userSelect: 'none',
            }}
            role="button"
            tabIndex={0}
        >
            {/* Sender */}
            <Typography noWrap sx={{ flex: '0 0 160px', color: 'text.secondary', fontSize: 13 }}>
                {from}
            </Typography>
            {/* Subject + Snippet */}
            <Box sx={{ flex: '1 1 0', overflow: 'hidden', minWidth: 0 }}>
                <Typography noWrap sx={{ color: 'text.primary', fontSize: 13 }}>
                    {obj.subject}
                </Typography>
                <Typography noWrap level="body-xs" sx={{ color: 'text.tertiary', fontSize: 11 }}>
                    {obj.snippet}
                </Typography>
            </Box>
            {/* Date/Time */}
            <Typography
                noWrap
                level="body-xs"
                sx={{ flex: '0 0 70px', textAlign: 'right', color: 'text.secondary', fontWeight: selected ? 700 : 400, fontSize: 13 }}
            >
                {formatEmailDate(obj.date)}
            </Typography>
        </Box>
    )
}
